"use client";
import { ark } from "../factory.js";
import { useProgressContext } from "./use-progress-context.js";
import { forwardRef } from "react";
import { mergeProps } from "@zag-js/react";
import { jsx } from "react/jsx-runtime";
//#region src/components/progress/progress-value-text.tsx
var ProgressValueText = forwardRef((props, ref) => {
	const { children, ...rest } = props;
	const progress = useProgressContext();
	const mergedProps = mergeProps(progress.getValueTextProps(), rest);
	return /* @__PURE__ */ jsx(ark.span, {
		...mergedProps,
		ref,
		children: children || progress.percentAsString
	});
});
ProgressValueText.displayName = "ProgressValueText";
//#endregion
export { ProgressValueText };
